import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Link } from 'react-router';
import Helpers from '~/utils/Helpers';
import StringService from '~/utils/StringService';
import LibraryHelper from '~/utils/LibraryHelper';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
type CSComponentRowProps = {
  searchResult: object;
  queryWords?: any[];
  vcPageState: object;
};
const CSComponentRow: React.SFC<CSComponentRowProps> = props => {
  const {
    searchResult,
    queryWords,
    vcPageState: { shouldShowVeracodePage },
  } = props;
  const { model: comp, _vulnCount = null } = searchResult;
  const descriptionText = comp.description ? comp.description : 'Description pending';
  const versions = comp.versions;
  const licenseNames = LibraryHelper.getUniqueCleanLicenseNames(versions);
  const licenseNamesText = (
    <span>
      {licenseNames.length > 1
        ? 'Licenses vary by version'
        : licenseNames.length === 1
        ? `License: ${licenseNames[0]}`
        : ''}
    </span>
  );
  let compURL, compTitleContent, compTitle;
  if (comp.id && comp.name && comp.languageType && comp.coordinateType) {
    compURL =
      StringService.createSEOComponentItemUrl(
        comp.name,
        comp.languageType,
        comp.id,
        comp.coordinateType
      ) + '/summary';
  } else if (comp.id) {
    compURL = `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/components/${comp.id}`;
  } else {
    // somehow don't have a comp id, so there's something wrong
    compURL = '404';
  }
  // component names can be -- if they are blank -- sourced by the coords so only populate the coords if they are different from the name.
  if (
    comp.name &&
    comp.coordiante1 &&
    comp.languageType === 'Java' &&
    comp.name !== comp.coordinate1
  ) {
    compTitleContent =
      comp.name + ' (' + comp.coordinate1 + ' ' + (comp.coordinate2 ? comp.coordinate2 : '') + ')';
  } else {
    compTitleContent = comp.name;
  }
  compTitle = (
    <Link
      to={compURL}
      //eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={Helpers.highlightItems(compTitleContent, queryWords, 85)}
    />
  );
  const sanitizedPackageManagerType = Helpers.sanitizePackageManagerType(comp.coordinateType);
  const vcFontSizeClass = classNames({
    'font--12': shouldShowVeracodePage,
  });
  const vcFontFamilyClass = classNames({
    'font-family--titillium-light': shouldShowVeracodePage,
  });
  return (
    <div className="grid pt-- bo-b--2 border-color--muted-light">
      <div className="grid__item col-1-1">
        <div className="">
          <div className="grid grid--middle ph--">
            <div className="grid__item col-3-5">
              <div className="">
                <div className="col-1-1 text--uppercase color--white p- lh grid font-family--body">
                  <div
                    className={`col-1-3 bg-color--primary-dark pv--- pl-- ${vcFontSizeClass} border-color--primary-dark bo-v--1 `}
                  >
                    Library Artifact
                  </div>
                  <div
                    className={`col-1-3 bg-color--black-dark pv--- pl-- ${vcFontSizeClass} border-color--black-dark bo-v--1`}
                  >
                    {'SRCCLR-LID-' + comp.id}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="grid__item col-1-1">
              <h1 className="font--h5 mv-- antialiased">{compTitle}</h1>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`grid__item col-1-1 pv- pr- ${vcFontFamilyClass}`}
        //eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={Helpers.highlightItems(descriptionText, queryWords, 400)}
      />

      <div className="grid__item col-1-1 pv-">
        <div className="grid bg-color--white-medium grid--middle pv--">
          <div className="col-1-5 grid__item">Latest Version: {comp.latestReleaseVersion}</div>

          <div className="col-2-5 grid__item">
            {(_vulnCount >= 0 || _vulnCount === null) && (
              <div className="col-1-1 grid grid__item grid--middle">
                <div className="col-3-5 grid__item">Number of Vulnerabilities:</div>
                <div className="col-2-5 grid__item">
                  <div
                    className={`col-5-8 text--center color--white ph- pv-- ${
                      _vulnCount > 0 ? 'bg-color--danger' : 'bg-color--muted'
                    } font-family--body`}
                  >
                    {_vulnCount || 0}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-1-5 grid__item grid grid--middle">{licenseNamesText}</div>

          <div className="col-1-5 grid__item">
            {Helpers.sanitizeLanguageType(comp.languageType)}{' '}
            {sanitizedPackageManagerType && `(${sanitizedPackageManagerType})`}
          </div>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    vcPageState: state.vcPageState,
  };
}
export default connect(mapStateToProps)(CSComponentRow);
